export const ValidarContrasena = (texto) => {
  let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?#&])([A-Za-z\d$@$!%*?#&]|[^ ]){8,15}$/;
  return texto.match(regex);
}